import React from 'react';
import { useQuery } from '@apollo/client';
import { Grid, CircularProgress, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { aftermarketPartnerApi, usePartner } from 'modules/aftermarket';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { partnerProfileDefaultConfig } from '../constants';
import { PartnerProfileFormValues } from '../types';
import { PartnerProfileForm } from './PartnerProfileForm';
import { PortalConfigurationRenderProps } from '../../types';
import { useSelector } from 'react-redux';

export const PartnerProfileManagement = ({}: PortalConfigurationRenderProps) => {
  const account = useSelector<any, any>(state => state.account);
  const partnerDynamicsProfileId = account?.partner?.partnerDynamicsProfileId;
  const partnerProfileId = account?.partner?.partnerProfileId;

  const { isPartnerProfileUpdating, handleUpdatePartnerProfile } = usePartner();

  const { loading, data } = useQuery(aftermarketPartnerApi.getPartnerProfile, {
    skip: !partnerDynamicsProfileId || !partnerProfileId,
    variables: {
      id: partnerProfileId,
    },
  });

  if (typeof partnerDynamicsProfileId !== 'string') return null;

  const defaultValues: PartnerProfileFormValues = {
    ...partnerProfileDefaultConfig,
    availableToPro: data?.partner?.availableToPro,
  };

  const handleSave = async (formData: PartnerProfileFormValues) => {
    await handleUpdatePartnerProfile(
      {
        partnerDynamicsProfileId,
        availableToPro: formData.availableToPro,
      },
      api => ({
        refetchQueries: [api.partnerApi.getPartnerProfile],
        awaitRefetchQueries: true,
      })
    );
  };

  return (
    <Grid item sm={12} md={6}>
      <CardContainer title="Partner Profile Management">
        <RenderWithFallback
          isLoading={loading}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          <PartnerProfileForm
            isLoading={isPartnerProfileUpdating}
            defaultValues={defaultValues}
            onConfirm={handleSave}
          />
        </RenderWithFallback>
      </CardContainer>
    </Grid>
  );
};
